module.exports = __webpack_public_path__ + "static/media/Events.116425f1.scss";


//////////////////
// WEBPACK FOOTER
// ./src/components/Events/Events.scss
// module id = 37
// module chunks = 0